/**
 * Singleton slides the reader cannot comment on. The viewer's footer has to
 * agree with this, because it reserves the space the comment bar occupies.
 */
const NON_CASUAL_SLIDES = ["intro", "toc", "key-takeaways", "faq", "feedback"];

export function hasCommentSection(slideId: string | undefined | null): boolean {
  return !!slideId && !NON_CASUAL_SLIDES.includes(slideId);
}
